import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  Stack,
  Divider,
  CircularProgress,
  Paper,
  useTheme,
  useMediaQuery,
  Button,
  TextField,
} from "@mui/material";
import {
  LocalShipping,
  Inventory,
  CheckCircle,
  Schedule,
} from "@mui/icons-material";
import Manubar from "./Manubar";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Security from "./Security";
import Productstraking from "./Productstraking";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import "./m.css";
import "./loader.css";
import Modal from "@mui/material/Modal";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const TrackOrder = () => {
  const order_id = secureLocalStorage.getItem("orderid");

  const [showorderlist, setShoworderlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);
  const [convertOpen, setConvertOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [leaseCalculation, setLeaseCalculation] = useState(null);
  const [loadingCalc, setLoadingCalc] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [buyOpen, setBuyOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");

  const fetchOrderData = async () => {
    if (!order_id) {
      setError("Missing order ID");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const data = { order_id: order_id };
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/track_my_order`,
        data,
      );
      console.log(response);
      setShoworderlist(response.data.data || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching order data:", err);
      setError("Failed to load order details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, [order_id]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const fetchLeaseCalculation = async () => {
    try {
      setLoadingCalc(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/lease_calculation`,
        { order_id: showorderlist[0]?.order_id },
      );
      setLeaseCalculation(response.data.data);
    } catch (error) {
      setLeaseCalculation(null);
      console.error("Error fetching lease calculation:", error);
    } finally {
      setLoadingCalc(false);
    }
  };

  const handleLeaseCalculation = () => {
    fetchLeaseCalculation();
    handleOpen();
  };

  const handleCancelOrder = async () => {
    try {
      setCancelLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/cancel_order`,
        {
          order_id: showorderlist[0]?.order_id,
          user_id: showorderlist[0]?.user_id,
          order_status: "Cancelled",
          region: "yyyy",
        },
      );

      toast.success("Order cancelled successfully");
      handleClose();
      fetchOrderData();
    } catch (error) {
      console.error("Cancel order failed", error);
      toast.error("Failed to cancel order");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleBuyCancelOrder = async () => {
    try {
      setCancelLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/cancel_order`,
        {
          order_id: showorderlist[0]?.order_id,
          user_id: showorderlist[0]?.user_id,
          order_status: "Cancelled",
          region: "yyyy",
        },
      );
      console.log(response);
      toast.success("Order cancelled successfully");
      setBuyOpen(false);
      fetchOrderData();
    } catch (error) {
      console.error("Cancel order failed", error);
      toast.error("Failed to cancel order");
    } finally {
      setCancelLoading(false);
    }
  };

  const handleConvertToBuy = async () => {
    try {
      setCancelLoading(true);

      const remaining_price = showorderlist[0]?.products.reduce(
        (total, item) => {
          const price = Number(item.price?.replace(/,/g, "") || 0);
          const salePrice = Number(item.sale_price?.replace(/,/g, "")) || 0;
          return total + (salePrice - price);
        },
        0,
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/update_booking_order`,
        {
          order_id: showorderlist[0]?.order_id,
          // user_id: showorderlist[0]?.user_id,
          available_status: "Buy",
          grand_total: showorderlist[0]?.grand_total?.replace(/,/g, ""),
          remaining_price: String(remaining_price),
        },
      );
      console.log(response);
      toast.success("Order converted to buy successfully");
      setConvertOpen(false);
      fetchOrderData();
    } catch (error) {
      console.error("Cancel order failed", error);
      toast.error("Failed to convert to buy");
    } finally {
      setCancelLoading(false);
    }
  };

  return (
    <>
      {/* Header Section */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header style={{ width: "100%" }}>
        <Shearchbar />
        <Navbar />
      </header>

      {/* Main Content */}
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Container
          maxWidth={false}
          sx={{ py: 4, px: isMobile ? 2 : 4 }}
          disableGutters
        >
          {/* Header Section */}
          <Box
            sx={{
              width: "100%",
              mb: 4,
              backgroundColor: "#160015", // Dark purple background
              borderRadius: 3,
              p: 4,
              color: "#fee894", // Light yellow text
              boxShadow: "0 8px 20px rgba(22, 0, 21, 0.2)",
              border: "2px solid #fee894",
            }}
          >
            <Stack
              direction={isMobile ? "column" : "row"}
              alignItems={isMobile ? "flex-start" : "center"}
              spacing={3}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fee894", // Light yellow circle
                  borderRadius: "50%",
                  p: 2,
                  color: "#160015", // Dark purple icon
                }}
              >
                <LocalShipping sx={{ fontSize: isMobile ? 32 : 48 }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant={isMobile ? "h5" : "h4"}
                  component="h1"
                  sx={{
                    fontWeight: 700,
                    mb: 1,
                    color: "#fee894",
                  }}
                >
                  Track Your Order
                </Typography>

                <Chip
                  label={`Order ID: ${showorderlist[0]?.order_no}`}
                  variant="filled"
                  sx={{
                    backgroundColor: "#fee894",
                    color: "#160015",
                    fontWeight: 600,
                    border: "1px solid #fee894",
                  }}
                />
              </Box>

              <Typography
                variant={isMobile ? "h5" : "h4"}
                component="h1"
                sx={{
                  fontWeight: 700,
                  mb: 1,
                  color: "#fee894",
                }}
              >
                {showorderlist[0]?.order_status !== "Delivered" && (
                  <Button
                    variant="contained"
                    sx={{
                      fontWeight: 700,
                      m: 1,
                      color: "#160015",
                      backgroundColor: "#fee894",
                      borderRadius: 5,
                      height: "32px",
                      "&.Mui-disabled": {
                        backgroundColor: "#fee894",
                        color: "#160015",
                        opacity: 1,
                      },
                    }}
                    onClick={() => setBuyOpen(true)}
                    disabled={
                      showorderlist[0]?.order_status === "Cancelled"
                        ? true
                        : false
                    }
                  >
                    {showorderlist[0]?.order_status === "Cancelled"
                      ? "Order Cancelled"
                      : "Cancel Order"}
                  </Button>
                )}

                {showorderlist[0]?.available_status !== "Buy" &&
                  showorderlist[0]?.order_status === "Delivered" && (
                    <Button
                      variant="contained"
                      sx={{
                        fontWeight: 700,
                        m: 1,
                        color: "#160015",
                        backgroundColor: "#fee894",
                        borderRadius: 5,
                        height: "32px",
                      }}
                      onClick={handleLeaseCalculation}
                      disabled={
                        showorderlist[0]?.order_status === "Cancelled"
                          ? true
                          : false
                      }
                    >
                      {showorderlist[0]?.order_status === "Cancelled"
                        ? "Order Cancelled"
                        : "Cancel Lease (2 days)"}
                    </Button>
                  )}

                {showorderlist[0]?.available_status !== "Buy" &&
                  showorderlist[0]?.order_status === "Delivered" && (
                    <Button
                      variant="contained"
                      sx={{
                        fontWeight: 700,
                        m: 1,
                        color: "#160015",
                        backgroundColor: "#fee894",
                        borderRadius: 5,
                        height: "32px",
                      }}
                      onClick={() => setConvertOpen(true)}
                      disabled={
                        showorderlist[0]?.order_status === "Cancelled"
                          ? true
                          : false
                      }
                    >
                      {showorderlist[0]?.order_status === "Cancelled"
                        ? "Order Cancelled"
                        : "Convert to Buy"}
                    </Button>
                  )}
              </Typography>

              {showorderlist[0]?.order_date && (
                <Box
                  sx={{
                    textAlign: isMobile ? "left" : "right",
                    backgroundColor: "rgba(254, 232, 148, 0.15)", // Semi-transparent light yellow
                    p: 2,
                    borderRadius: 2,
                    border: "1px solid #fee894",
                  }}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    sx={{ color: "#fee894" }}
                  >
                    Order Date
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, color: "#fee894" }}
                  >
                    {formatDate(showorderlist[0].order_date)}
                  </Typography>
                </Box>
              )}
            </Stack>
          </Box>

          <Grid container spacing={3} sx={{ width: "100%" }}>
            {/* Tracking Progress */}
            <Grid item xs={12} lg={5} sx={{ width: "50%" }}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 3,
                  height: "100%",
                  backgroundColor: "#ffffff",
                  border: "2px solid #160015",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: "0 8px 25px rgba(22, 0, 21, 0.1)",
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 4 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#160015",
                        borderRadius: "50%",
                        p: 1.5,
                        color: "#fee894",
                        border: "2px solid #fee894",
                      }}
                    >
                      <Inventory sx={{ fontSize: 24 }} />
                    </Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 700,
                        color: "#160015", // Dark purple text
                      }}
                    >
                      Order Tracking
                    </Typography>
                  </Stack>
                  <Productstraking />
                </CardContent>
              </Card>
            </Grid>

            {/* Order Details */}
            <Grid item xs={12} lg={7} sx={{ width: "47%" }}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 3,
                  border: "2px solid #160015",
                  overflow: "hidden",
                  backgroundColor: "#ffffff",
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    backgroundColor: "#160015", // Dark purple header
                    color: "#fee894", // Light yellow text
                    borderBottom: "2px solid #fee894",
                  }}
                >
                  <Stack
                    direction={isMobile ? "column" : "row"}
                    justifyContent="space-between"
                    alignItems={isMobile ? "flex-start" : "center"}
                    spacing={2}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      Order Items
                    </Typography>
                    <Chip
                      label={showorderlist[0]?.order_status || "Processing"}
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        px: 2,
                        backgroundColor: "#fee894", // Light yellow background
                        color: "#160015", // Dark purple text
                        border: "1px solid #fee894",
                      }}
                    />
                  </Stack>
                </Box>

                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 300,
                      flexDirection: "column",
                      gap: 3,
                    }}
                  >
                    <CircularProgress
                      size={60}
                      thickness={4}
                      sx={{ color: "#160015" }} // Dark purple spinner
                    />
                    <Typography variant="h6" sx={{ color: "#160015" }}>
                      Loading order details...
                    </Typography>
                  </Box>
                ) : error ? (
                  <Box
                    sx={{
                      textAlign: "center",
                      py: 8,
                      px: 3,
                    }}
                  >
                    <Schedule
                      sx={{
                        fontSize: 64,
                        color: "#160015", // Dark purple icon
                        mb: 3,
                        opacity: 0.7,
                      }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ color: "#160015" }}
                      gutterBottom
                    >
                      {error}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#666" }}>
                      Please check your order ID and try again.
                    </Typography>
                  </Box>
                ) : showorderlist.length > 0 ? (
                  <Box>
                    {showorderlist[0]?.products?.map((item, index) => (
                      <Box key={index}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            mb: 3,
                            borderRadius: 3,
                            border: "2px solid #f0f0f0",
                            backgroundColor: "#ffffff",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                              borderColor: "#160015",
                              backgroundColor: "#fef9e7", // Light yellow hover
                            },
                          }}
                        >
                          <Grid container spacing={3} alignItems="center">
                            <Grid
                              item
                              xs={12}
                              sm={3}
                              sx={{ textAlign: "center" }}
                            >
                              <Avatar
                                src={`${process.env.REACT_APP_API}uploads/${item.product_image}`}
                                sx={{
                                  width: 120,
                                  height: 120,
                                  margin: "0 auto",
                                  border: "3px solid",
                                  borderColor: "#160015", // Dark purple border
                                  borderRadius: 2,
                                }}
                                variant="rounded"
                              />
                            </Grid>
                            <Grid item xs={12} sm={9}>
                              <Stack spacing={2}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    fontWeight: 700,
                                    color: "#160015", // Dark purple text
                                  }}
                                >
                                  {item.product_title}
                                </Typography>
                                <Stack
                                  direction={isMobile ? "column" : "row"}
                                  spacing={isMobile ? 2 : 4}
                                  sx={{ width: "100%" }}
                                >
                                  <Box sx={{ flex: 1 }}>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: "#666" }}
                                      display="block"
                                      gutterBottom
                                    >
                                      Price
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: "1.1rem",
                                        color: "#160015", // Dark purple price
                                      }}
                                    >
                                      ₹{item.price}
                                    </Typography>
                                  </Box>
                                  <Box sx={{ flex: 1 }}>
                                    <Typography
                                      width={"100px"}
                                      variant="caption"
                                      sx={{ color: "#666" }}
                                      display="block"
                                      gutterBottom
                                    >
                                      No Of Products
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: "1.1rem",
                                        color: "#160015", // Dark purple text
                                      }}
                                    >
                                      {item.no_of_product}
                                    </Typography>
                                  </Box>
                                  {item.size && (
                                    <Box sx={{ flex: 1 }}>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#666" }}
                                        display="block"
                                        gutterBottom
                                      >
                                        Size
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "1.1rem",
                                          color: "#160015",
                                        }}
                                      >
                                        {item.size}
                                      </Typography>
                                    </Box>
                                  )}
                                </Stack>
                                {item.tracking_status && (
                                  <Chip
                                    icon={<CheckCircle />}
                                    label={item.tracking_status.toUpperCase()}
                                    sx={{
                                      fontWeight: 600,
                                      alignSelf: "flex-start",
                                      backgroundColor: "#160015", // Dark purple background
                                      color: "#fee894", // Light yellow text
                                      border: "1px solid #160015",
                                      "& .MuiChip-icon": {
                                        color: "#fee894",
                                      },
                                    }}
                                  />
                                )}
                              </Stack>
                            </Grid>
                          </Grid>
                        </Paper>
                        {index < showorderlist[0]?.products?.length - 1 && (
                          <Divider sx={{ my: 2, opacity: 0.3 }} />
                        )}
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      textAlign: "center",
                      py: 10,
                      px: 3,
                    }}
                  >
                    <Schedule
                      sx={{
                        fontSize: 80,
                        color: "#160015", // Dark purple icon
                        mb: 3,
                        opacity: 0.3,
                      }}
                    />
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        fontWeight: 600,
                        color: "#160015",
                      }}
                    >
                      No Order Found
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#666",
                        maxWidth: 400,
                        margin: "0 auto",
                      }}
                    >
                      We couldn't find any order with the provided ID. Please
                      check your order ID and try again.
                    </Typography>
                  </Box>
                )}

                {/* Shipping Address */}
                <Box
                  sx={{
                    p: 3,
                    borderTop: "2px solid #f0f0f0",
                    backgroundColor: "#fef9e7", // Light yellow background
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <Box
                      sx={{
                        backgroundColor: "#160015", // Dark purple circle
                        color: "#fee894", // Light yellow icon
                        borderRadius: "50%",
                        p: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #fee894",
                      }}
                    >
                      <LocalShipping />
                    </Box>

                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 700,
                          mb: 0.5,
                          color: "#160015",
                        }}
                      >
                        Shipping Address
                      </Typography>

                      <Typography variant="body2" sx={{ color: "#666" }}>
                        {showorderlist[0]?.address
                          ? `${showorderlist[0]?.address}, ${showorderlist[0]?.city}, ${showorderlist[0]?.pin_code}`
                          : "Address not available"}
                      </Typography>
                    </Box>
                  </Stack>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="lease-modal-title"
      >
        <Box
          sx={{
            ...style,
            width: 420,
            border: "2px solid #160015",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: "#160015",
              padding: "20px 24px",
              borderBottom: "2px solid #fee894",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#fee894",
                margin: 0,
              }}
            >
              Cancel Lease Calculation
            </Typography>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              backgroundColor: "#fef9e7",
              padding: "24px",
            }}
          >
            {loadingCalc ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <CircularProgress sx={{ color: "#160015" }} />
                <Typography variant="body2" sx={{ mt: 2, color: "#160015" }}>
                  Calculating refund...
                </Typography>
              </Box>
            ) : leaseCalculation ? (
              <>
                <Stack spacing={2} sx={{ mb: 3 }}>
                  {/* Order ID */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #160015",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#160015" }}
                    >
                      Order No:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#160015", fontWeight: 500 }}
                    >
                      {showorderlist[0]?.order_no}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #160015",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#160015" }}
                    >
                      Delivery On:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#160015", fontWeight: 500 }}
                    >
                      {formatDate(showorderlist[0]?.completed_date)}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #160015",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#160015" }}
                    >
                      Today:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#160015", fontWeight: 500 }}
                    >
                      {formatDate(new Date().toDateString())}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: "#fee894",
                      padding: "12px 16px",
                      borderRadius: "8px",
                    }}
                  >
                    {/* Title */}
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#160015",
                        fontSize: "1rem",
                        mb: 1,
                      }}
                    >
                      Calculation Breakdown
                    </Typography>

                    {/* Row 1 */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                      }}
                    >
                      <Typography sx={{ color: "#160015", fontWeight: 500 }}>
                        Days Since Delivery
                      </Typography>
                      <Typography sx={{ color: "#160015", fontWeight: 600 }}>
                        {showorderlist[0]?.lease_days} days
                      </Typography>
                    </Box>

                    {/* Row 2 */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        mt: 0.5,
                      }}
                    >
                      <Typography sx={{ color: "#160015", fontWeight: 500 }}>
                        Applicable Slab
                      </Typography>
                      <Typography sx={{ color: "#160015", fontWeight: 600 }}>
                        15 days
                      </Typography>
                    </Box>
                  </Box>

                  {/* Total Amount */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "1px solid #160015",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#160015" }}
                    >
                      Security Deposit:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#160015", fontWeight: 600 }}
                    >
                      ₹{leaseCalculation.grand_total}
                    </Typography>
                  </Box>

                  {/* Deduction */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      backgroundColor: "#fee894",
                      borderRadius: "8px",
                      border: "1px solid #160015",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#160015" }}
                    >
                      Lease Amount:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#d32f2f", fontWeight: 600 }}
                    >
                      ₹{leaseCalculation.deduction_amount}
                    </Typography>
                  </Box>

                  {/* Refund Amount */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      border: "2px solid #160015",
                      marginTop: "8px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 700, color: "#160015" }}
                    >
                      Refund Amount:
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ color: "#160015", fontWeight: 700 }}
                    >
                      ₹{leaseCalculation.refund_amount}
                    </Typography>
                  </Box>
                </Stack>

                {/* Modal Actions */}
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    sx={{
                      border: "2px solid #160015",
                      color: "#160015",
                      fontWeight: 600,
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "rgba(22, 0, 21, 0.1)",
                        borderColor: "#160015",
                      },
                    }}
                  >
                    Close
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleCancelOrder}
                    disabled={cancelLoading}
                    sx={{
                      backgroundColor: "#160015",
                      color: "#fee894",
                      border: "2px solid #160015",
                      fontWeight: 600,
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#fee894",
                        color: "#160015",
                        borderColor: "#160015",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#ccc",
                        color: "#666",
                        borderColor: "#ccc",
                      },
                    }}
                  >
                    {cancelLoading ? (
                      <>
                        <CircularProgress
                          size={16}
                          sx={{ color: "#fee894", marginRight: 1 }}
                        />
                        Cancelling...
                      </>
                    ) : (
                      "Return Lease"
                    )}
                  </Button>
                </Stack>
              </>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 4,
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #160015",
                  padding: "20px",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "#d32f2f", fontWeight: 600 }}
                >
                  Unable to calculate refund. Please try again.
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Modal>

      <Modal
        open={buyOpen}
        onClose={() => setBuyOpen(false)}
        aria-labelledby="cancel-order-modal-title"
      >
        <Box
          sx={{
            ...style,
            width: 520,
            border: "2px solid #160015",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: "#160015",
              padding: "20px 24px",
              borderBottom: "2px solid #fee894",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#fee894",
              }}
            >
              Cancel Order
            </Typography>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              backgroundColor: "#fef9e7",
              padding: "24px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                color: "#160015",
                mb: 2,
              }}
            >
              Are you sure you want to cancel this order?
            </Typography>

            <TextField
              fullWidth
              multiline
              rows={3}
              label="Reason for cancellation"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              sx={{
                mb: 3,
                backgroundColor: "#fff",
              }}
            />

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  borderColor: "#160015",
                  color: "#160015",
                  fontWeight: 600,
                }}
                onClick={() => setBuyOpen(false)}
                disabled={cancelLoading}
              >
                No, Go Back
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#160015",
                  color: "#fee894",
                  fontWeight: 700,
                }}
                onClick={handleBuyCancelOrder}
                disabled={cancelLoading}
              >
                {cancelLoading ? (
                  <>
                    <CircularProgress
                      size={16}
                      sx={{ color: "#fee894", marginRight: 1 }}
                    />
                    Cancelling...
                  </>
                ) : (
                  "Yes, Cancel Order"
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={convertOpen}
        onClose={() => setConvertOpen(false)}
        aria-labelledby="lease-modal-title"
      >
        <Box
          sx={{
            ...style,
            width: 420,
            border: "2px solid #160015",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              backgroundColor: "#160015",
              padding: "20px 24px",
              borderBottom: "2px solid #fee894",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#fee894",
                margin: 0,
              }}
            >
              Convert to Buy
            </Typography>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              backgroundColor: "#fef9e7",
              padding: "24px",
            }}
          >
            <Stack spacing={2} sx={{ mb: 3 }}>
              {/* Order ID */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 12px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #160015",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#160015" }}
                >
                  Best Buy:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#160015", fontWeight: 500 }}
                >
                  ₹{showorderlist[0]?.grand_total || "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 12px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #160015",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#160015" }}
                >
                  Security Deposit:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#160015", fontWeight: 500 }}
                >
                  ₹{showorderlist[0]?.grand_total || "N/A"}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 12px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #160015",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#160015" }}
                >
                  Balance Amount to Pay:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#160015", fontWeight: 500 }}
                >
                  ₹
                  {showorderlist[0]?.products.reduce((total, item) => {
                    const price = Number(item.price?.replace(/,/g, "") || 0);
                    const salePrice =
                      Number(item.sale_price?.replace(/,/g, "")) || 0;
                    return total + (salePrice - price);
                  }, 0)}
                </Typography>
              </Box>
            </Stack>

            {/* Modal Actions */}
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button
                onClick={() => setConvertOpen(false)}
                variant="outlined"
                sx={{
                  border: "2px solid #160015",
                  color: "#160015",
                  fontWeight: 600,
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "rgba(22, 0, 21, 0.1)",
                    borderColor: "#160015",
                  },
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleConvertToBuy}
                disabled={cancelLoading}
                sx={{
                  backgroundColor: "#160015",
                  color: "#fee894",
                  border: "2px solid #160015",
                  fontWeight: 600,
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#fee894",
                    color: "#160015",
                    borderColor: "#160015",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#ccc",
                    color: "#666",
                    borderColor: "#ccc",
                  },
                }}
              >
                {cancelLoading ? (
                  <>
                    <CircularProgress
                      size={16}
                      sx={{ color: "#fee894", marginRight: 1 }}
                    />
                    processing...
                  </>
                ) : (
                  "Buy"
                )}
              </Button>
            </Stack>
          </Box>
        </Box>
      </Modal>

      <Security />
      <Footer />
    </>
  );
};

export default TrackOrder;
